<script>
import FAQPage from '@/pages/pagesContent/FAQ/FAQ-page.vue';
import constants from '@/pages/pagesContent/constants';
import {
  DownOutlined,
  UpOutlined,
} from '@ant-design/icons-vue';
import { Modal } from 'ant-design-vue';
import bem from '@/utils/bem';
import HeaderComponent from '@/pages/pagesContent/headerComponent/header-component.vue';
import { mapActions, mapState } from 'vuex';
import LogoComponent from '@/pages/pagesContent/LogoComponent/Logo-component.vue';
import BlockWithCustomProducts from '@/pages/pagesContent/blockWithCustomProducts/block-with-custom-products.vue';
import StoriesBlock from '@/components/newDesign/stories-block.vue';
import StudiosBlock from '@/components/newDesign/studios-block.vue';
import NewBannerWithImageBlock from '@/components/newDesign/new-banner-with-image-block.vue';
import BigImageWithTabsBlock from '@/components/newDesign/big-image-with-tabs-block.vue';
import NewBigImageWithTabsBlock from '@/components/newDesign/new-big-image-with-tabs-block.vue';
import HeaderBlock from '@/components/newDesign/header-block.vue';
import WizardSteps from '@/components/newDesign/wizard-steps.vue';
import ReadyOrderBlock from '@/components/newDesign/ready-order-block.vue';
import TrustExperienceBlock from '@/components/newDesign/trust-experience-block.vue';
import OneTabWithImageBlock from '@/components/newDesign/one-tab-with-image-block.vue';
import BlogsBlock from '@/components/newDesign/blogs-block.vue';
import ReliveMemoriesBlock from '@/components/newDesign/relive-memories-block.vue';
import ToTheTopBlock from '@/components/newDesign/to-the-top-block.vue';
import DigitizeTypesList from '@/components/newDesign/digitize-types-list.vue';
import EditTitleModal from '@/components/pageContent/modules/EditTitleModal.vue';
import EditDescriptionModal from '@/components/pageContent/modules/EditDescriptionModal.vue';
import EditButtonModal from '@/components/pageContent/modules/EditButtonModal.vue';
import EditPriceModal from '@/components/pageContent/modules/EditPriceModal.vue';
import ImageUploadModal from '@/components/pageContent/modules/ImageUploadModal.vue';
import MediaSliderModal from '@/components/pageContent/modules/MediaSliderModal.vue';
import EditTitleWithLinesModal from '@/components/pageContent/modules/EditTitleWithLinesModal.vue';

const b = bem('content-page');

const {
  GROUPS_OF_PAGES,
  PAGES_DATA,
  NAV_GROUPS,
  NAV_SUBGROUPS,
  NAV_LINKS,
} = constants;

export default {
  components: {
    LogoComponent,
    HeaderComponent,
    DownOutlined,
    UpOutlined,
    FAQPage,
    BlockWithCustomProducts,
    StoriesBlock,
    StudiosBlock,
    NewBannerWithImageBlock,
    BigImageWithTabsBlock,
    NewBigImageWithTabsBlock,
    HeaderBlock,
    WizardSteps,
    ReadyOrderBlock,
    TrustExperienceBlock,
    OneTabWithImageBlock,
    BlogsBlock,
    ReliveMemoriesBlock,
    ToTheTopBlock,
    DigitizeTypesList,
    EditTitleModal,
    EditDescriptionModal,
    EditButtonModal,
    EditPriceModal,
    ImageUploadModal,
    MediaSliderModal,
    EditTitleWithLinesModal,
  },
  data() {
    return {
      selectedComponent: null,
      groupsOfPages: GROUPS_OF_PAGES,
      currentGroup: GROUPS_OF_PAGES.digitize,
      currentPage: { label: 'Tape Transfer', value: 'tapeTransfer' },
      pageComponentsList: PAGES_DATA.tapeTransfer,
      isMobile: false,
      isEditMode: true,
      navGroups: NAV_GROUPS,
      navSubgroups: NAV_SUBGROUPS,
      navLinks: NAV_LINKS,
      activeGroup: null,
      activeSubgroup: null,
      activeSubKey: null,
      editModalVisible: false,
      editModalType: null,
      editingBlockIndex: null,
      editingBlockData: {},
      editingStudioIndex: null,
      isSyncing: false,
      pageSettingsId: null,
      isPublished: false,
    };
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      getPagesListAction: 'collections/getPagesList',
      getPageContentAction: 'pageContent/getPageContent',
      editPageContentAction: 'pageContent/editPageContent',
      createPageContentAction: 'pageContent/createPageContent',
      deletePageContentAction: 'pageContent/deletePageContent',
    }),
    onSelect({ group, page }) {
      this.currentGroup = group;
      this.currentPage = page;
      this.pageComponentsList = PAGES_DATA[page.value] || [];
      this.getPageContentAction(page.value);
    },
    onSelectComponent(value) {
      this.selectedComponent = value;
    },
    getTypeButton(key) {
      return this.currentGroup.key === key ? 'primary' : 'default';
    },
    handleGroupClick(group) {
      if (group.isLink) {
        this.selectPage(group.pageKey, group.title);
        this.activeGroup = null;
        this.activeSubgroup = null;
        this.activeSubKey = null;
      } else {
        this.activeGroup = this.activeGroup === group.id ? null : group.id;
        this.activeSubgroup = null;
        this.activeSubKey = null;
      }
    },
    handleSubgroupClick(subgroup) {
      if (subgroup.isLink) {
        this.selectPage(subgroup.pageKey, subgroup.text);
        this.activeSubKey = null;
      } else {
        this.activeSubKey = this.activeSubKey === subgroup.subKey ? null : subgroup.subKey;
      }
    },
    handleLinkClick(link) {
      this.selectPage(link.pageKey, link.text);
    },
    selectPage(pageKey, label) {
      this.currentPage = { label, value: pageKey };
      this.pageComponentsList = PAGES_DATA[pageKey] || [];
      this.getPageContentAction(pageKey);
    },
    isGroupActive(groupId) {
      return this.activeGroup === groupId;
    },
    isSubgroupActive(subKey) {
      return this.activeSubKey === subKey;
    },
    isPageSelected(pageKey) {
      return this.currentPage.value === pageKey;
    },
    toggleEditMode() {
      this.isEditMode = !this.isEditMode;
      if (this.isEditMode) {
        this.isMobile = false;
      }
    },
    async handleMoveBlock(index, direction) {
      const targetIndex = direction === 'up' ? index - 1 : index + 1;
      if (targetIndex < 0 || targetIndex >= this.pageComponentsList.length) return;

      const newList = [...this.pageComponentsList];
      const [movedItem] = newList.splice(index, 1);
      newList.splice(targetIndex, 0, movedItem);

      newList.forEach((item, idx) => {
        const updatedItem = item;
        updatedItem.content.index = idx;
      });

      this.pageComponentsList = newList;

      const currentItem = newList[targetIndex];
      const swappedItem = newList[index];

      // Send both index updates in parallel to avoid watcher race condition
      const promises = [];

      if (currentItem.content.id) {
        promises.push(this.editPageContentAction({
          id: currentItem.content.id,
          page: this.currentPage.value,
          silent: true,
          params: {
            index: targetIndex,
            content: JSON.stringify({ ...currentItem.content, index: targetIndex }),
          },
        }));
      } else {
        promises.push(this.createPageContentAction({
          page: this.currentPage.value,
          silent: true,
          params: {
            name: currentItem.componentName,
            pageKey: this.currentPage.value,
            content: JSON.stringify({ ...currentItem.content, index: targetIndex }),
            index: targetIndex,
          },
        }));
      }

      if (swappedItem.content.id) {
        promises.push(this.editPageContentAction({
          id: swappedItem.content.id,
          page: this.currentPage.value,
          silent: true,
          params: {
            index,
            content: JSON.stringify({ ...swappedItem.content, index }),
          },
        }));
      } else {
        promises.push(this.createPageContentAction({
          page: this.currentPage.value,
          silent: true,
          params: {
            name: swappedItem.componentName,
            pageKey: this.currentPage.value,
            content: JSON.stringify({ ...swappedItem.content, index }),
            index,
          },
        }));
      }

      await Promise.all(promises);
    },
    async handleBlockUpdate(index, updatedContent) {
      if (!this.checkPublishedBeforeEdit()) return;
      const item = this.pageComponentsList[index];

      const fullContent = {
        ...item.content,
        ...updatedContent,
      };

      if (item.content.id) {
        const payload = {
          id: item.content.id,
          page: this.currentPage.value,
          params: { content: JSON.stringify(fullContent) },
        };
        await this.editPageContentAction(payload);
      } else {
        const createPayload = {
          page: this.currentPage.value,
          params: {
            name: item.componentName,
            pageKey: this.currentPage.value,
            content: JSON.stringify(fullContent),
            index,
          },
        };
        await this.createPageContentAction(createPayload);
      }
    },
    async handleTogglePublish() {
      const newState = !this.isPublished;
      const content = JSON.stringify({ isPublished: newState });

      // Ищем pageSettings в сторе напрямую — защита от рассинхрона this.pageSettingsId
      const existingRecords = Array.isArray(this.pageContent)
        ? this.pageContent.filter((itm) => itm.name === 'pageSettings')
        : [];
      const existingRecord = existingRecords.length
        ? existingRecords.reduce((latest, itm) => (itm.id > latest.id ? itm : latest))
        : null;
      const targetId = existingRecord?.id || this.pageSettingsId;

      if (targetId) {
        await this.editPageContentAction({
          id: targetId,
          page: this.currentPage.value,
          params: { content },
        });
      } else {
        await this.createPageContentAction({
          page: this.currentPage.value,
          params: {
            name: 'pageSettings',
            pageKey: this.currentPage.value,
            content,
            index: -1,
          },
        });
      }
    },
    checkPublishedBeforeEdit() {
      if (this.isPublished) {
        Modal.warning({
          title: 'Page is published',
          content: 'Turn off the isPublished toggle first, make your changes, then turn it back on when you\'re done.',
          okText: 'OK',
          centered: true,
          class: 'custom-modal',
          width: 1200,
        });
        return false;
      }
      return true;
    },
    async syncMissingBlocksToBackend() {
      const promises = this.pageComponentsList
        .filter((item) => !item.content?.id)
        .map((item) => {
          const index = this.pageComponentsList.indexOf(item);
          const fullContent = Array.isArray(item.content)
            ? item.content
            : { ...item.content, index };
          return this.createPageContentAction({
            page: this.currentPage.value,
            params: {
              name: item.componentName,
              pageKey: this.currentPage.value,
              content: JSON.stringify(fullContent),
              index,
            },
          });
        });

      if (promises.length > 0) {
        await Promise.all(promises);
      }
    },
    openEditModal(index, fieldType, studioIndex = null) {
      if (!this.checkPublishedBeforeEdit()) return;
      this.editingBlockIndex = index;
      this.editModalType = fieldType;
      this.editingStudioIndex = studioIndex;

      const blockContent = this.pageComponentsList[index].content;

      if (fieldType === 'firstTitle' || fieldType === 'secondTitle') {
        this.editingBlockData = {
          titleData: blockContent[fieldType] || [],
        };
      } else if (fieldType === 'mainTitle') {
        let titleData = blockContent.mainTitle;
        if (typeof titleData === 'string') {
          titleData = [{
            id: Date.now(),
            text: titleData,
            textMob: titleData,
            color: '#FFFFFF',
            colorMob: '#FFFFFF',
          }];
        }
        this.editingBlockData = {
          titleData: titleData || [],
        };
      } else if (fieldType === 'mainTitleMob') {
        this.editingBlockData = {
          titleData: blockContent.mainTitleMob || [],
        };
      } else if (studioIndex !== null && blockContent.studioBlock) {
        const studio = blockContent.studioBlock[studioIndex];

        if (fieldType === 'studioTitle') {
          let titleData = studio.title;
          if (typeof titleData === 'string') {
            const isDark = studioIndex % 2 === 0;
            titleData = [{
              id: Date.now(),
              text: titleData,
              textMob: titleData,
              color: isDark ? '#FFFFFF' : '#293241',
              colorMob: isDark ? '#FFFFFF' : '#293241',
            }];
          }
          this.editingBlockData = {
            titleData: titleData || [],
          };
        } else if (fieldType === 'studioImage') {
          this.editingBlockData = {
            imageSrc: studio.imageSrc || '',
            imageMobileSrc: studio.imageMobileSrc || '',
            imageText: studio.imageText || '',
            imageTextMobile: studio.imageTextMobile || '',
          };
        } else if (fieldType === 'studioDescription') {
          this.editingBlockData = {
            description: studio.description || '',
            descriptionMobile: studio.descriptionMobile || '',
          };
        } else if (fieldType === 'studioButton') {
          this.editingBlockData = {
            buttonText: studio.buttonText || '',
            buttonTextMobile: studio.buttonTextMobile || '',
            buttonLink: studio.buttonLink || '',
          };
        }
      } else {
        this.editingBlockData = { ...blockContent };
      }

      this.editModalVisible = true;
    },
    closeEditModal() {
      this.editModalVisible = false;
      this.editModalType = null;
      this.editingBlockIndex = null;
      this.editingBlockData = {};
      this.editingStudioIndex = null;
    },
    handleModalSave(values) {
      if (this.editingBlockIndex === null) {
        return;
      }

      const blockContent = this.pageComponentsList[this.editingBlockIndex].content;
      let updatedContent;

      if (this.editModalType === 'firstTitle' || this.editModalType === 'secondTitle') {
        updatedContent = {
          ...blockContent,
          [this.editModalType]: values,
        };
      } else if (this.editModalType === 'mainTitle') {
        updatedContent = {
          ...blockContent,
          mainTitle: values,
        };
      } else if (this.editModalType === 'mainTitleMob') {
        updatedContent = {
          ...blockContent,
          mainTitleMob: values,
        };
      } else if (this.editingStudioIndex !== null && blockContent.studioBlock) {
        const studioBlock = [...blockContent.studioBlock];
        const studio = { ...studioBlock[this.editingStudioIndex] };

        if (this.editModalType === 'studioTitle') {
          studio.title = values;
        } else if (this.editModalType === 'studioImage') {
          studio.imageSrc = values.imageSrc || studio.imageSrc;
          studio.imageMobileSrc = values.imageMobileSrc || studio.imageMobileSrc;
          studio.imageText = values.imageText ?? studio.imageText;
          studio.imageTextMobile = values.imageTextMobile ?? studio.imageTextMobile;
        } else if (this.editModalType === 'studioDescription') {
          studio.description = values.description || studio.description;
          studio.descriptionMobile = values.descriptionMobile || studio.descriptionMobile;
        } else if (this.editModalType === 'studioButton') {
          studio.buttonText = values.buttonText || studio.buttonText;
          studio.buttonTextMobile = values.buttonTextMobile || studio.buttonTextMobile;
          studio.buttonLink = values.buttonLink || studio.buttonLink;
        }

        studioBlock[this.editingStudioIndex] = studio;
        updatedContent = {
          ...blockContent,
          studioBlock,
        };
      } else {
        updatedContent = {
          ...blockContent,
          ...values,
        };
      }

      this.handleBlockUpdate(this.editingBlockIndex, updatedContent);
      this.closeEditModal();
    },
    async handleResetBlock(index) {
      const item = this.pageComponentsList[index];
      if (!item.content.id) {
        return;
      }

      const baseComponentsList = PAGES_DATA[this.currentPage.value] || [];
      const defaultComponent = baseComponentsList.find(
        (comp) => comp.componentName === item.componentName,
      );

      if (!defaultComponent) {
        return;
      }

      await this.deletePageContentAction({
        id: item.content.id,
        page: this.currentPage.value,
      });

      const toggleControlFields = [
        'isRight',
        'withMainTitle',
        'withSecondTitle',
        'isDarkButton',
        'withBottomSection',
      ];

      const currentIndex = item.content.index;
      const resetContent = {
        ...defaultComponent.content,
        name: item.componentName,
        pageKey: this.currentPage.value,
        index: currentIndex,
      };

      toggleControlFields.forEach((field) => {
        if (item.content[field] !== undefined) {
          resetContent[field] = item.content[field];
        }
      });

      this.pageComponentsList[index].content = resetContent;
    },
    isBlockModified(index) {
      const item = this.pageComponentsList[index];
      if (!item || !item.content.id) {
        return false;
      }

      const baseComponentsList = PAGES_DATA[this.currentPage.value] || [];
      const defaultComponent = baseComponentsList.find(
        (comp) => comp.componentName === item.componentName,
      );

      if (!defaultComponent) {
        return false;
      }

      // Compare key fields that indicate modification
      const currentContent = { ...item.content };
      const defaultContent = { ...defaultComponent.content };

      // Remove system fields and toggle control fields from comparison
      // Toggle controls are layout settings, not content modifications
      const excludedFields = [
        'id', 'index', 'name', 'pageKey', 'isEdit',
        'isRight', 'withMainTitle', 'withSecondTitle', 'isDarkButton', 'withBottomSection',
      ];
      excludedFields.forEach((field) => {
        delete currentContent[field];
        delete defaultContent[field];
      });

      // Simple deep comparison
      return JSON.stringify(currentContent) !== JSON.stringify(defaultContent);
    },
  },
  computed: {
    ...mapState({
      pageList: (state) => state.collections.collectionsPages,
      pageContent: (state) => state.pageContent.pageContent,
    }),
  },
  mounted() {
    this.getPagesListAction();
    this.getPageContentAction(this.currentPage.value);
  },
  watch: {
    pageList: {
      handler(newValue) {
        this.groupsOfPages = newValue.reduce((acc, item) => {
          if (['photo_art', 'photo_restoration', 'pm_cart', 'printed_story', 'proof'].includes(item)) {
            return acc;
          }
          return {
            ...acc,
            commercial: {
              ...acc.commercial,
              pages: [...acc.commercial.pages, {
                label: `${item.replaceAll('_', ' ')}`,
                value: item,
                path: item,
              }],
            },
          };
        }, GROUPS_OF_PAGES);
      },
      deep: true,
    },
    pageContent: {
      handler(newValue) {
        if (!Array.isArray(newValue)) {
          return;
        }
        const baseComponentsList = PAGES_DATA[this.currentPage.value] || [];

        // Имена компонентов, которые были переименованы — их старые записи нужно удалить из бэкенда
        // Исключаем из deprecated те компоненты, которые ещё используются на текущей странице
        const currentPageComponentNames = new Set(
          baseComponentsList.map((item) => item.componentName),
        );
        const DEPRECATED_COMPONENT_NAMES = ['bigImageWithTabsBlock'].filter(
          (name) => !currentPageComponentNames.has(name),
        );

        // Извлекаем pageSettings — мета-запись, не блок страницы
        // Берём запись с максимальным id (защита от дублей при двойном нажатии toggle)
        const pageSettingsRecords = newValue.filter((itm) => itm.name === 'pageSettings');
        const pageSettingsRecord = pageSettingsRecords.length
          ? pageSettingsRecords.reduce((latest, itm) => (itm.id > latest.id ? itm : latest))
          : null;
        // Удаляем дублирующие записи pageSettings (все кроме той что с макс. id)
        pageSettingsRecords.forEach((itm) => {
          if (itm.id !== pageSettingsRecord?.id) {
            this.deletePageContentAction({ id: itm.id, page: this.currentPage.value });
          }
        });
        if (pageSettingsRecord) {
          this.pageSettingsId = pageSettingsRecord.id;
          try {
            const parsed = typeof pageSettingsRecord.content === 'string'
              ? JSON.parse(pageSettingsRecord.content)
              : pageSettingsRecord.content;
            this.isPublished = parsed.isPublished ?? false;
          } catch {
            this.isPublished = false;
          }
        } else {
          this.pageSettingsId = null;
          this.isPublished = false;
        }

        // If backend has data, use backend order; otherwise use default order
        if (newValue.length > 0) {
          // Build a map of backend items by name for quick lookup
          const backendItemsMap = new Map();
          newValue.forEach((itm) => {
            // Пропускаем мета-запись pageSettings — она не блок страницы
            if (itm.name === 'pageSettings') return;
            // Удаляем устаревшие записи (переименованные компоненты)
            if (DEPRECATED_COMPONENT_NAMES.includes(itm.name)) {
              this.deletePageContentAction({
                id: itm.id,
                page: this.currentPage.value,
              });
              return;
            }

            let parsedContent = {};
            try {
              parsedContent = typeof itm.content === 'string'
                ? JSON.parse(itm.content)
                : itm.content;
            } catch {
              parsedContent = {};
            }
            // Если запись с таким name уже есть — удаляем дубль с меньшим id из БД
            const existing = backendItemsMap.get(itm.name);
            if (existing) {
              const keep = itm.id > existing.id ? itm : existing;
              const remove = itm.id > existing.id ? existing : itm;
              this.deletePageContentAction({
                id: remove.id,
                page: this.currentPage.value,
              });
              backendItemsMap.set(itm.name, {
                ...keep,
                parsedContent: keep === itm ? parsedContent : existing.parsedContent,
              });
            } else {
              backendItemsMap.set(itm.name, {
                ...itm,
                parsedContent,
              });
            }
          });

          // Create list: items from backend sorted by index, plus items not in backend
          const itemsFromBackend = [];
          const itemsNotInBackend = [];

          baseComponentsList.forEach((item, defaultIndex) => {
            const backendItem = backendItemsMap.get(item.componentName);
            const isArrayContent = Array.isArray(item.content);

            if (backendItem) {
              // For array-based content (like bigImageWithTabsBlock)
              let mergedContent;
              if (isArrayContent) {
                const backendIsArray = Array.isArray(backendItem.parsedContent);
                // Use backend array if valid, otherwise fallback to default
                // Also check if backend array has items (not empty)
                const useBackend = backendIsArray && backendItem.parsedContent.length > 0;
                mergedContent = useBackend ? backendItem.parsedContent : item.content;
              } else {
                mergedContent = {
                  ...item.content,
                  ...backendItem.parsedContent,
                  id: backendItem.id,
                  name: backendItem.name,
                  pageKey: backendItem.pageKey,
                  index: Number(backendItem.index),
                };
              }
              itemsFromBackend.push({
                ...item,
                content: mergedContent,
                backendIndex: Number(backendItem.index),
              });
            } else {
              // For items not in backend, use default content
              const defaultContent = isArrayContent
                ? item.content
                : { ...item.content, index: defaultIndex };
              itemsNotInBackend.push({
                ...item,
                content: defaultContent,
                defaultIndex,
              });
            }
          });

          // Sort backend items by their index
          itemsFromBackend.sort((a, c) => a.backendIndex - c.backendIndex);

          // Merge: use backend order for items in backend, insert others at their default position
          const allItems = [];

          // First, add all items from backend in their sorted order
          itemsFromBackend.forEach((backendItem) => {
            allItems.push(backendItem);
          });

          // Then, insert items not in backend at appropriate positions
          itemsNotInBackend.forEach((notInBackendItem) => {
            // Find where this item should be inserted based on its default index
            // Insert at the end if no better position found
            let insertIndex = allItems.length;

            // Try to find a position near its default index
            // by looking at which backend items are around it in the base list
            const { defaultIndex } = notInBackendItem;

            // Find items that come before and after this item in baseComponentsList
            for (let i = 0; i < allItems.length; i += 1) {
              const currentItem = allItems[i];
              // Find the default index of currentItem in baseComponentsList
              const currentDefaultIdx = baseComponentsList.findIndex(
                (base) => base.componentName === currentItem.componentName,
              );
              // If currentItem's default position is after notInBackendItem,
              // insert notInBackendItem before it
              if (currentDefaultIdx > defaultIndex) {
                insertIndex = i;
                break;
              }
            }

            allItems.splice(insertIndex, 0, notInBackendItem);
          });

          const newList = allItems.map((item, idx) => {
            // For array-based content, don't spread into object
            if (Array.isArray(item.content)) {
              return {
                ...item,
                content: item.content,
              };
            }
            return {
              ...item,
              content: {
                ...item.content,
                index: idx,
              },
            };
          });

          this.pageComponentsList = newList;
        } else {
          // No backend data - use default order
          const newList = baseComponentsList.map((item, idx) => {
            // For array-based content, don't spread into object
            if (Array.isArray(item.content)) {
              return {
                ...item,
                content: item.content,
              };
            }
            return {
              ...item,
              content: {
                ...item.content,
                index: idx,
              },
            };
          });
          this.pageComponentsList = newList;
        }

        // Синхронизируем блоки без id на бэкенд (один раз, без рекурсии)
        if (!this.isSyncing) {
          this.isSyncing = true;
          this.syncMissingBlocksToBackend().finally(() => {
            this.isSyncing = false;
          });
        }

        this.$forceUpdate();
      },
      immediate: true,
    },
  },
};
</script>

<template>
  <div class="content-page-wrapper">
  <div :class="b('nav-container')">
    <div :class="b('nav-row')">
      <div :class="b('nav-label')">Pages:</div>
      <div :class="b('nav-buttons')">
        <a-button
          v-for="group in navGroups"
          :key="group.id"
          size="large"
          :type="isGroupActive(group.id) || isPageSelected(group.pageKey) ? 'primary' : 'default'"
          @click="handleGroupClick(group)"
        >
          {{ group.title }}
          <DownOutlined v-if="!group.isLink" />
        </a-button>
      </div>
    </div>

    <div v-if="activeGroup && navSubgroups[activeGroup]" :class="b('nav-row', { sub: true })">
      <div :class="b('nav-buttons')">
        <a-button
          v-for="subgroup in navSubgroups[activeGroup]"
          :key="subgroup.text"
          size="middle"
          :type="isSubgroupActive(subgroup.subKey) || isPageSelected(subgroup.pageKey)
            ? 'primary' : 'default'"
          @click="handleSubgroupClick(subgroup)"
        >
          {{ subgroup.text }}
          <DownOutlined v-if="!subgroup.isLink" />
        </a-button>
      </div>
    </div>

    <div v-if="activeSubKey && navLinks[activeSubKey]" :class="b('nav-row', { links: true })">
      <div :class="b('nav-buttons')">
        <a-button
          v-for="link in navLinks[activeSubKey]"
          :key="link.pageKey"
          size="small"
          :type="isPageSelected(link.pageKey) ? 'primary' : 'default'"
          @click="handleLinkClick(link)"
        >
          {{ link.text }}
        </a-button>
      </div>
    </div>
  </div>
  <div v-if="selectedComponent">
    <FAQPage v-if="selectedComponent?.value === 'faq'" :currentPage="currentPage" />
    <HeaderComponent v-if="selectedComponent?.value === 'headerBlock'" :currentPage="currentPage" />
    <LogoComponent v-if="selectedComponent?.value === 'logo'" :currentPage="currentPage" />
    <BlockWithCustomProducts
      v-if="selectedComponent?.value === 'blockWithCustomProducts'"
      :currentPage="currentPage"
    />
  </div>
  <div :class="b('page-header-section')">
    <h2 :class="b('center-title')">
      {{`Selected page > ${currentPage?.label || ''}`}}
    </h2>
    <div :class="b('page-actions-row')">
      <button :class="b('preview-link')" @click="toggleEditMode">
        {{ isEditMode ? 'PREVIEW' : 'BACK TO EDITS' }}
      </button>
      <div v-if="isEditMode" :class="b('toggle-row')">
        <span :class="b('toggle-label')">isPublished</span>
        <button
          type="button"
          role="switch"
          :aria-checked="isPublished"
          :class="b('toggle', { active: isPublished, published: true })"
          @click="handleTogglePublish"
        >
          <span :class="b('toggle-ball', { active: isPublished })" />
        </button>
      </div>
<!--      <a-popconfirm-->
<!--        v-if="isEditMode"-->
<!--        title="Are you sure you want to clear all content for this page?"-->
<!--        ok-text="Yes"-->
<!--        cancel-text="No"-->
<!--        @confirm="handleClearAllContent"-->
<!--      >-->
<!--        <button :class="b('clear-all-btn')">-->
<!--          CLEAR ALL-->
<!--        </button>-->
<!--      </a-popconfirm>-->
      <div v-if="!isEditMode" :class="b('toggle-row')">
        <span :class="b('toggle-label')">Desktop</span>
        <button
          type="button"
          role="switch"
          :aria-checked="isMobile"
          :class="b('toggle', { active: isMobile })"
          @click="isMobile = !isMobile"
        >
          <span :class="b('toggle-ball', { active: isMobile })" />
        </button>
        <span :class="b('toggle-label')">Mobile</span>
      </div>
    </div>
  </div>
  <div :class="b('page-components-list', { isMobile })">
    <div
      :class="b('block-row', { isEditMode })"
      v-for="(item, index) in pageComponentsList"
      :key="item.componentName + '-' + index"
    >
      <div :class="b('block-content', { isEditMode, isMobile })">
        <HeaderBlock
          v-if="item.componentName === 'headerBlock'"
          :data="item.content"
          :isMobileView="isMobile"
          :isEditMode="isEditMode"
          :isPublished="isPublished"
          @update="(data) => handleBlockUpdate(index, { ...item.content, ...data })"
        />
        <StudiosBlock
          v-if="item.componentName === 'studiosBlock'"
          :data="item.content"
          :isMobileView="isMobile"
          :isEditMode="isEditMode"
          @update="(data) => handleBlockUpdate(index, { ...item.content, ...data })"
        />
        <NewBannerWithImageBlock
          v-if="item.componentName === 'newBannerWithImageBlock'"
          :data="item.content"
          :isMobileView="isMobile"
          :isEditMode="isEditMode"
          :pageKey="currentPage.value"
          @update="(data) => handleBlockUpdate(index, { ...item.content, ...data })"
        />
        <StoriesBlock
          v-if="item.componentName === 'storiesBlock'"
          :data="item.content"
          :isMobileView="isMobile"
          :isEditMode="isEditMode"
          :isPublished="isPublished"
          @update="(data) => handleBlockUpdate(index, { ...item.content, ...data })"
        />
        <BigImageWithTabsBlock
          v-if="item.componentName === 'bigImageWithTabsBlock'"
          :titles-list="item.content.titlesList || []"
          :tabs="item.content.tabs || []"
          :isMobileView="isMobile"
          :currentPage="currentPage"
          :isEditMode="isEditMode"
          :isPublished="isPublished"
          @update="(tabs) => handleBlockUpdate(index, { ...item.content, tabs })"
          @update-title="(titlesList) => handleBlockUpdate(index, { ...item.content, titlesList })"
        />
        <NewBigImageWithTabsBlock
          v-if="item.componentName === 'newBigImageWithTabsBlock'"
          :titles-list="item.content.titlesList || []"
          :tabs="item.content.tabs || []"
          :isMobileView="isMobile"
          :currentPage="currentPage"
          :isEditMode="isEditMode"
          :isPublished="isPublished"
          @update="(tabs) => handleBlockUpdate(index, { ...item.content, tabs })"
          @update-title="(titlesList) => handleBlockUpdate(index, { ...item.content, titlesList })"
        />
        <WizardSteps
          v-if="item.componentName === 'wizardSteps'"
          :data="item.content"
          :isMobileView="isMobile"
          :currentPage="currentPage"
          :isEditMode="isEditMode"
          :isPublished="isPublished"
          @update="(data) => handleBlockUpdate(index, { ...item.content, ...data })"
        />
        <ReadyOrderBlock
          v-if="item.componentName === 'readyOrderBlock'"
          :data="item.content"
          :isMobileView="isMobile"
          :isEditMode="isEditMode"
          :isPublished="isPublished"
          @update="(data) => handleBlockUpdate(index, { ...item.content, ...data })"
        />
        <TrustExperienceBlock
          v-if="item.componentName === 'trustExperienceBlock'"
          :data="item.content"
          :isMobileView="isMobile"
          :currentPage="currentPage"
          :isEditMode="isEditMode"
          :isPublished="isPublished"
          @update="(data) => handleBlockUpdate(index, { ...item.content, ...data })"
        />
        <OneTabWithImageBlock
          v-if="item.componentName === 'oneTabWithImageBlock'"
          :data="item.content"
          :isMobileView="isMobile"
          :isEditMode="isEditMode"
          :isPublished="isPublished"
          :pageKey="currentPage.value"
          @update="(data) => handleBlockUpdate(index, { ...item.content, ...data })"
        />
        <ReliveMemoriesBlock
          v-if="item.componentName === 'reliveMemoriesBlock'"
          :data="item.content"
          :isMobileView="isMobile"
          :isEditMode="isEditMode"
          :isPublished="isPublished"
          @update="(data) => handleBlockUpdate(index, { ...item.content, ...data })"
        />
        <BlogsBlock
          v-if="item.componentName === 'blogsBlock'"
          :data="item.content"
          :isMobileView="isMobile"
          :isEditMode="isEditMode"
          :pageKey="currentPage.value"
          @update="(data) => handleBlockUpdate(index, { ...item.content, ...data })"
        />
        <ToTheTopBlock
          v-if="item.componentName === 'toTheTopBlock'"
          :isMobileView="isMobile"
        />
        <DigitizeTypesList
          v-if="item.componentName === 'digitizeTypesList'"
          :titleData="item.content.titleData || {}"
          :typesList="item.content.typesList || []"
          :isMobileView="isMobile"
          :isEditMode="isEditMode"
          :isPublished="isPublished"
          @update-title="(titleData) => handleBlockUpdate(index, {
            ...item.content,
            titleData: { textList: titleData }
          })"
          @update-types="(typesList) => handleBlockUpdate(index, { ...item.content, typesList })"
        />
      </div>

      <div v-if="isEditMode" :class="b('block-controls')">
        <button
          v-if="index > 0"
          :class="b('block-control-btn')"
          title="Move up"
          @click="handleMoveBlock(index, 'up')"
        >
          <UpOutlined />
        </button>
        <button
          v-if="index < pageComponentsList.length - 1"
          :class="b('block-control-btn')"
          title="Move down"
          @click="handleMoveBlock(index, 'down')"
        >
          <DownOutlined />
        </button>
        <button
          v-if="isBlockModified(index)"
          :class="b('block-control-btn', { danger: true })"
          title="Reset to default"
          @click="handleResetBlock(index)"
        >
          Reset
        </button>
      </div>
    </div>
  </div>

  <EditTitleModal
    :visible="editModalVisible && editModalType === 'title'"
    :title="editingBlockData.title || ''"
    :titleMobile="editingBlockData.titleMobile || ''"
    modal-title="Edit Title"
    @close="closeEditModal"
    @save="handleModalSave"
  />

  <EditTitleModal
    :visible="editModalVisible && editModalType === 'subTitle'"
    :title="editingBlockData.subTitle || ''"
    :titleMobile="editingBlockData.subTitleMobile || ''"
    modal-title="Edit Subtitle"
    first-field-label="Subtitle (Desktop)"
    first-field-placeholder="Enter subtitle for desktop"
    second-field-label="Subtitle (Mobile)"
    second-field-placeholder="Enter subtitle for mobile"
    @close="closeEditModal"
    @save="(v) => handleModalSave({ subTitle: v.title, subTitleMobile: v.titleMobile })"
  />

  <EditDescriptionModal
    :visible="editModalVisible && editModalType === 'description'"
    :description="editingBlockData.description || ''"
    :descriptionMobile="editingBlockData.descriptionMobile || ''"
    @close="closeEditModal"
    @save="handleModalSave"
  />

  <EditButtonModal
    :visible="editModalVisible && editModalType === 'button'"
    :buttonText="editingBlockData.buttonText || ''"
    :buttonTextMobile="editingBlockData.buttonTextMobile || ''"
    :buttonLink="editingBlockData.buttonLink || ''"
    @close="closeEditModal"
    @save="handleModalSave"
  />

  <EditPriceModal
    :visible="editModalVisible && editModalType === 'price'"
    :beforeText="editingBlockData.beforeText || ''"
    :afterText="editingBlockData.afterText || ''"
    :productId="editingBlockData.productId || 0"
    :optionId="editingBlockData.optionId || 0"
    @close="closeEditModal"
    @save="handleModalSave"
  />

  <ImageUploadModal
    :visible="editModalVisible && editModalType === 'images'"
    :images="editingBlockData.blocks || editingBlockData.images || []"
    @close="closeEditModal"
    @save="(values) => handleModalSave({ blocks: values.images })"
  />

  <MediaSliderModal
    :visible="editModalVisible && editModalType === 'media'"
    :slides="editingBlockData.blocks || []"
    :isShowVideo="editingBlockData.isShowVideo || false"
    :videoUrl="editingBlockData.videoUrl || ''"
    @close="closeEditModal"
    @save="handleModalSave"
  />

  <EditDescriptionModal
    :visible="editModalVisible && editModalType === 'studioDescription'"
    :description="editingBlockData.description || ''"
    :descriptionMobile="editingBlockData.descriptionMobile || ''"
    @close="closeEditModal"
    @save="handleModalSave"
  />

  <EditButtonModal
    :visible="editModalVisible && editModalType === 'studioButton'"
    :buttonText="editingBlockData.buttonText || ''"
    :buttonTextMobile="editingBlockData.buttonTextMobile || ''"
    :buttonLink="editingBlockData.buttonLink || ''"
    @close="closeEditModal"
    @save="handleModalSave"
  />

  <ImageUploadModal
    :visible="editModalVisible && editModalType === 'studioImage'"
    :image="editingBlockData.imageSrc || ''"
    :image-mobile="editingBlockData.imageMobileSrc || ''"
    :image-text="editingBlockData.imageText || ''"
    :image-text-mobile="editingBlockData.imageTextMobile || ''"
    :with-image-text="true"
    @close="closeEditModal"
    @save="(values) => handleModalSave({
      imageSrc: values.image || '',
      imageMobileSrc: values.imageMobile || '',
      imageText: values.imageText ?? '',
      imageTextMobile: values.imageTextMobile ?? ''
    })"
  />

  <EditTitleWithLinesModal
    :visible="editModalVisible && (
      editModalType === 'firstTitle' ||
      editModalType === 'secondTitle' ||
      editModalType === 'mainTitle' ||
      editModalType === 'studioTitle'
    )"
    :data="editingBlockData.titleData || []"
    @cancel="closeEditModal"
    @save="handleModalSave"
  />
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/variables';
@import "@/styles/media";
@import "@/styles/fonts";

.content-page {
  &__button-block-title {
    font-size: 36px;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(36);
    }
  }

  &__nav-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin: 64px 20px 0;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(16);
      margin: vw-full(64) vw-full(20) 0;
    }
  }

  &__nav-row {
    display: flex;
    align-items: center;
    gap: 16px;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(16);
    }

    &_sub {
      padding-left: 130px;

      @include mediaMinMax(1025, $normal) {
        padding-left: vw-full(130);
      }
    }

    &_links {
      padding-left: 130px;

      @include mediaMinMax(1025, $normal) {
        padding-left: vw-full(130);
      }
    }
  }

  &__nav-label {
    font-size: 36px;
    font-weight: 500;
    white-space: nowrap;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(36);
    }
  }

  &__nav-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(12);
    }
  }

  &__buttons-menu {
    display: flex;
    align-items: center;
    margin: 64px 0 0 20px;
    gap: 20px;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(20);
      margin: vw-full(64) 0 0 vw-full(20);
    }
  }

  &__page-header-section {
    margin: 40px 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 24px;

    @include mediaMinMax(1025, $normal) {
      margin: vw-full(40) 0;
      gap: vw-full(24);
    }
  }

  &__center-title {
    font-family: Montserrat, sans-serif;
    font-size: 28px;
    font-weight: 500;
    color: #293241;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    text-align: center;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(28);
    }
  }

  &__preview-link {
    background: none;
    border: none;
    color: #5e5d5d;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 20px;
    font-weight: 400;
    line-height: normal;
    text-decoration: underline;
    cursor: pointer;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(20);
    }
  }

  &__toggle-row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(12);
    }
  }

  &__toggle {
    width: 56px;
    height: 28px;
    border-radius: 14px;
    border: 2px solid #242424;
    background: #fff;
    cursor: pointer;
    position: relative;
    transition: all 0.2s ease;
    padding: 0;

    @include mediaMinMax(1025, $normal) {
      width: vw-full(56);
      height: vw-full(28);
      border-radius: vw-full(14);
      border-width: vw-full(2);
    }

    &_published#{&}_active {
      border-color: #4caf50;
      background: #e8f5e9;
    }
  }

  &__toggle-ball {
    position: absolute;
    top: 50%;
    left: 2px;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #242424;
    transition: all 0.2s ease;

    @include mediaMinMax(1025, $normal) {
      left: vw-full(2);
      width: vw-full(20);
      height: vw-full(20);
    }

    &_active {
      left: calc(100% - 22px);

      @include mediaMinMax(1025, $normal) {
        left: calc(100% - #{vw-full(22)});
      }
    }

    .content-page__toggle_published & {
      &_active {
        background: #4caf50;
      }
    }
  }

  &__toggle-label {
    color: #242424;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 20px;
    font-weight: 400;
    line-height: normal;
    text-decoration: underline;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(20);
    }
  }

  &__page-actions-row {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 24px;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(24);
    }
  }

  &__page-components-list {
    display: flex;
    margin: 0 auto;
    padding: 0 0 100px 0;
    width: 100%;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border: 1px solid $main-gray-color;

    @include mediaMinMax(1025, $normal) {
      padding: 0 0 vw-full(100) 0;
    }

    &_isMobile {
      .content-page__block-content {
        width: 412px;
        max-width: 412px;
      }
    }
  }

  &__page-components-list-toggle-button {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin: 20px 0;

    @include mediaMinMax(1025, $normal) {
      margin: vw-full(20) 0;
      gap: vw-full(16);
    }
  }

  &__block-row {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 60px;
    width: 100%;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(60);
    }

    &_isEditMode {
      border-bottom: 1px solid #e0e0e0;
      padding: 40px 0;

      @include mediaMinMax(1025, $normal) {
        padding: vw-full(40) 0;
      }
    }

    &:last-child {
      border-bottom: none;
    }
  }

  &__block-content {
    flex: 0 0 auto;
    width: 100%;

    &_isEditMode {
      width: 1800px;
      max-width: 1800px;

      @include mediaMinMax(1025, $normal) {
        width: vw-full(1800);
        max-width: vw-full(1800);
      }
    }
  }

  &__block-controls {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    top: 50%;
    transform: translateY(-50%);

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(8);
      padding-top: vw-full(20);
    }
  }

  &__block-control-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border-radius: 8px;
    background: #fff;
    border: 1px solid #d9d9d9;
    cursor: pointer;
    transition: all 0.2s;
    font-size: 20px;

    &:hover {
      background: #e6f7ff;
      border-color: #1890ff;
      color: #1890ff;
    }

    @include mediaMinMax(1025, $normal) {
      width: vw-full(60);
      height: vw-full(60);
      border-radius: vw-full(8);
      font-size: vw-full(20);
    }
  }

  &__block-name {
    font-size: 14px;
    font-weight: 500;
    color: #666;
    min-width: 180px;
    text-align: center;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(14);
      min-width: vw-full(180);
    }
  }

  &__clear-all-btn {
    background: #ff4d4f;
    border: none;
    color: #fff;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s;

    &:hover {
      background: #ff7875;
    }

    @include mediaMinMax(1025, $normal) {
      padding: vw-full(8) vw-full(16);
      font-size: vw-full(14);
      border-radius: vw-full(4);
    }
  }

}
</style>
